<template>
  <b-button
      @click="handleTileClick"
      variant="outline-dark"
      :style="`height:${dimension}px;width:${dimension}px; margin: 10px`"
  >
    <b-img
        v-bind="mainProps"
        :src="tileTPL.imgURL ? tileTPL.imgURL : null "
        rounded
        alt="Rounded image"
    />
    {{ tileTPL.name ? tileTPL.name : ''}}
    <template v-if="fieldKeys && Array.isArray(fieldKeys)">
      <div
          v-for="(aFieldKey, j) in fieldKeys"
          :key="`curr_${j}`"
      >
        <div>
          {{ `${fieldVal(aFieldKey)}  ${fieldMetric(aFieldKey)} `}}
        </div>
      </div>
    </template>
  </b-button>
</template>

<script>
export default {
  name: "HeartBeat_Tile",
  components: {},
  props: {
    profile: {
      type: Object,
      required: false,
      default: () => {return {}}
    },
    heartbeat: {
      type: Object,
      required: false,
      default: () => {return {}}
    },
    tileData: {
      type: Array,
      required: false,
      default: () => {return []}
    },
    tileKey:{
      type: String,
      required: false,
      default: ''
    },
    tileEntries: {
      type: Array,
      required: false,
      default: () => {return []}
    },
  },
  computed: {
    tileTPL(){
      let theTile = this.tileEntries &&  Array.isArray(this.tileEntries) && this.tileKey ?
          this.tileEntries.filter((aTile) => { return aTile.key === this.tileKey}):
          null;
      return theTile && Array.isArray(theTile) && theTile[0] ?
          theTile[0] : null ;
    },
    currTileDatum(){
      return this.localTileData[this.currIdx];
    },
    fields(){
      return this.currTileDatum && this.currTileDatum.fields ?
          this.currTileDatum.fields : {};
    },
    fieldKeys(){
      return this.fields ? Object.keys(this.fields) :[];
    },
    sortedTileData(){
      //@ToDo- need to incorporate the time as well
      return this.tileData && Array.isArray(this.tileData) ?
          this.localTileData.sort(
          (a,b)=>{
              return a._tracking_date_at && b._tracking_date_at ?
                  b._tracking_date_at.seconds - a._tracking_date_at.seconds: false;
          }
      ): [];
    }
  },
  beforeMount() {},
  mounted() {},
  methods: {
    handleTileClick() {
      this.$emit('tile-click-for-key', this.tileKey);
    },
    tileName(tileKey) {
      let theTile = this.tileEntries &&  Array.isArray(this.tileEntries) ?
          this.tileEntries.filter((aTile) => { return aTile.key === tileKey}):
          null;

      return theTile && Array.isArray(theTile) && theTile[0].hasOwnProperty('name') ?
          theTile[0].name :
          tileKey ? tileKey[0].toUpperCase() + tileKey.slice(1) : '' ;

    },
    fieldVal(fieldKey){
      return this.currTileDatum && this.currTileDatum.fields ? this.currTileDatum.fields[fieldKey] : '';
    },
    fieldMetric(fieldKey){
      return this.tileTPL && this.tileTPL.metrics ? this.tileTPL.metrics[fieldKey] : '';
    }
  },
  data() {
    return {
      dimension: 150,
      localTileData: this.tileData && Array.isArray(this.tileData) ? this.tileData : [],
      maxIdx: this.tileData &&  Array.isArray(this.tileData) ? this.tileData.length - 1: null,
      currIdx: this.tileData &&  Array.isArray(this.tileData) ? this.tileData.length - 1: null,
      modalShow: false,
      mainProps: {
        blank: false,
        blankColor: '#777',
        width: 25,
        height: 25,
        class: 'm1'
      }
    }
  }
};
</script>


<style lang="scss" scoped>
</style>